<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            توزيع القوى العاملة والتغطية
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            التوزيع الجغرافي وتغطية السكان
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-workforce')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card primary">
          <div class="kpi-value">847,400</div>
          <div class="kpi-label">سكان المنطقة</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">0.3/1000</div>
          <div class="kpi-label">كثافة الأطباء</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">4</div>
          <div class="kpi-label">مناطق بتغطية ناقصة</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">2</div>
          <div class="kpi-label">مرافق تعتمد على متطوعين</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">التغطية حسب المرفق والمنطقة</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>المنطقة المخدومة</th>
            <th>عدد السكان</th>
            <th>الكادر الكلي</th>
            <th>نسبة التغطية</th>
            <th>مدة التنقل للمرفق</th>
            <th>ملاحظات</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>{{ item.area }}</td>
            <td>{{ item.population }}</td>
            <td>{{ item.totalStaff }}</td>
            <td>
              <v-chip
                :color="coverageColor(item.coverage)"
                size="small"
                variant="flat"
                >{{ item.coverage }}</v-chip
              >
            </td>
            <td>{{ item.travelTime }}</td>
            <td>{{ item.notes }}</td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    area: "الشيخ عثمان كامل",
    population: "450,000",
    totalStaff: 148,
    coverage: "منخفضة",
    travelTime: "0-30 دق",
    notes: "مرجعي رئيسي",
  },
  {
    name: "مستشفى الأمراض النفسية",
    area: "الشيخ عثمان + عدن",
    population: "محافظة",
    totalStaff: 44,
    coverage: "منخفضة",
    travelTime: "0-60 دق",
    notes: "الوحيد في المحافظة",
  },
  {
    name: "مجمع الشيخ عثمان",
    area: "وسط الشيخ عثمان",
    population: "80,000",
    totalStaff: 46,
    coverage: "متوسطة",
    travelTime: "0-15 دق",
    notes: "تحويل من المراكز",
  },
  {
    name: "مركز كود العثماني",
    area: "كود العثماني",
    population: "25,000",
    totalStaff: 5,
    coverage: "ناقصة جداً",
    travelTime: "0-20 دق",
    notes: "نقص حاد في الكادر",
  },
  {
    name: "مركز الممدارة",
    area: "الممدارة",
    population: "35,000",
    totalStaff: 24,
    coverage: "مقبولة",
    travelTime: "0-15 دق",
    notes: "—",
  },
  {
    name: "مركز المحاريق",
    area: "المحاريق",
    population: "30,000",
    totalStaff: 15,
    coverage: "ناقصة",
    travelTime: "0-20 دق",
    notes: "—",
  },
  {
    name: "مركز عبد القوي",
    area: "عبد القوي",
    population: "28,000",
    totalStaff: 16,
    coverage: "مقبولة",
    travelTime: "0-15 دق",
    notes: "—",
  },
  {
    name: "مركز ماري ستبوس",
    area: "الشيخ عثمان (نساء)",
    population: "42,000 ♀",
    totalStaff: 5,
    coverage: "ناقصة جداً",
    travelTime: "0-30 دق",
    notes: "متوقف",
  },
  {
    name: "جمعية حقوق الطفل",
    area: "الشيخ عثمان (أطفال)",
    population: "35,000 أطفال",
    totalStaff: 3,
    coverage: "ناقصة جداً",
    travelTime: "0-20 دق",
    notes: "متطوعون",
  },
];

const coverageColor = (value) => {
  if (value === "مقبولة") return "green";
  if (value === "متوسطة" || value === "ناقصة") return "orange";
  return "red";
};

const showView = (view) => console.log("Go to:", view);
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.primary {
  background: #f0f1f2;
  color: #4a4f55;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
